import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { ValueChange } from "./baseDetails";

export default function modelDataValueTimeSerieUpdateDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <ValueChange oldValue={row.old_timing_name} newValue={row.new_timing_name} />
        </ModelDataValueUpdateDetailsBase>
    );
}
